import { Component, input, linkedSignal, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { chooseFn, I18nModule, IconComponent, translator } from '@softline/ui-core';
import { isObjectSort, ObjectSort } from '@softline/core';
import { SortPropertyNamePipe } from './sort-property-name.pipe';
import { SortConfig } from '../../types/sort-config';

@Component({
    selector: 'soft-sort-form',
    imports: [CommonModule, I18nModule, SortPropertyNamePipe, IconComponent],
    templateUrl: './sort-form.component.html',
    styleUrls: ['./sort-form.component.css']
})
export class SortFormComponent {

  private readonly choose = chooseFn();
  private t = translator();

  sortInput = input.required<ObjectSort<any> | null | undefined>({alias: 'sort'})
  config = input.required<SortConfig>();
  sort = linkedSignal<Partial<ObjectSort<any>> | null | undefined>(() => this.sortInput());
  sortChange = output<ObjectSort<any> | null | undefined>()

  async onPropertyClick(): Promise<void>{
    const result = await this.choose({
      title: this.t('#APPLICATION.FILTER_AND_SORT.SORT.FIELD_PLACEHOLDER'),
      options: this.config()?.properties.map(o => ({label: o.title, value: o})) ?? []
    });
    if(result === 'DISMISSED')
      return;
    const sort = {
      ...this.sort(),
      direction: this.sort()?.direction ?? 'asc',
      property: result.property,
      comparator: result.comparer
    };
    this.sort.set(sort);
    this.sortChange.emit(sort);
  }

  async onDirectionClick(): Promise<void> {
    const result = await this.choose<'asc' | 'desc'>({
      title: this.t('#APPLICATION.FILTER_AND_SORT.SORT.FIELD_PLACEHOLDER'),
      options: [
        {value: 'asc', label: '#APPLICATION.FILTER_AND_SORT.SORT.ASC', icon: 'fa-regular fa-arrow-down-short-wide'},
        {value: 'desc', label: '#APPLICATION.FILTER_AND_SORT.SORT.DESC', icon: 'fa-regular fa-arrow-down-wide-short'}
      ]
    });
    if(result === 'DISMISSED')
      return;
    const sort = {...this.sort(), direction: result};
    this.sort.set(sort);
    if(isObjectSort(sort))
      this.sortChange.emit(sort);
  }

  removeSort(): void {
    this.sort.set(undefined);
    this.sortChange.emit(undefined);
  }
}
